import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const FolderOpenIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "folder-open",
  "FolderOpenIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M15.896 6.00002L13.496 14L-2.91493e-05 14L-2.86102e-05 1.66669L4.908 1.66669L6.908 3.33335L13.6666 3.33335L13.6666 6.00002L15.896 6.00002ZM12.3333 6.00002L12.3333 4.66669L6.42527 4.66669L4.42527 3.00002L1.33331 3.00002L1.33331 8.79106L2.17062 6.00002L12.3333 6.00002ZM1.56266 12.6667L3.16266 7.33335L14.104 7.33335L12.504 12.6667L1.56266 12.6667Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default FolderOpenIcon;
